module.exports = __webpack_public_path__ + "static/media/about7_.9b79b05c.jpg";